module.exports = __webpack_public_path__ + "static/media/sweetpotato.37a020cc.gif";